import { render, staticRenderFns } from "./emailVerification.vue?vue&type=template&id=49d1dae1&scoped=true&"
import script from "./emailVerification.vue?vue&type=script&lang=js&"
export * from "./emailVerification.vue?vue&type=script&lang=js&"
import style0 from "./emailVerification.vue?vue&type=style&index=0&id=49d1dae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d1dae1",
  null
  
)

export default component.exports